module.exports = __webpack_public_path__ + "static/media/appstore_icon.280f1e04.png";